import { Caption, Flex_unstable as Flex, Heading, WhatsappIcon } from '@farol-ds/react'
import { useUserSession } from '@jusbrasil-web/shared-user-session'
import { useState } from 'react'

import { buildWhatsappRedirect } from '../../utils/whatsapp-redirect'
import styles from './sticky-whatsapp-cta.module.scss'

const DEFAULT_WHATSAPP_MESSAGE = 'Olá! Tenho dúvidas sobre os meus direitos.'

export interface StickyWhatsappCTAProps {
  onToggleExpand?: () => void
  'aria-label'?: string
  whatsappMessage?: string
  onRedirect?: () => void
  defaultExpanded?: boolean
}

export const StickyWhatsappCTA = ({
  onToggleExpand,
  'aria-label': ariaLabel = 'Abrir chat no WhatsApp',
  whatsappMessage,
  onRedirect,
  defaultExpanded = false,
}: StickyWhatsappCTAProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded)
  const session = useUserSession()

  const handleClick = () => {
    setExpanded((prev) => !prev)
    onToggleExpand?.()
  }

  const whatsappHref = buildWhatsappRedirect({
    message: whatsappMessage ?? DEFAULT_WHATSAPP_MESSAGE,
    deviceId: session?.jdid,
    userId: session?.pid != null ? String(session.pid) : undefined,
  })

  const handleWhatsappClick = () => {
    onRedirect?.()
  }

  return (
    <div className={`${styles.root}${expanded ? ` ${styles.expanded}` : ''}`}>
      <Flex align="center" justify="center" asChild>
        <button
          className={styles.iconButton}
          onClick={handleClick}
          aria-label={ariaLabel}
          aria-expanded={expanded}
          type="button"
        >
          <WhatsappIcon aria-hidden="true" />
          <span className={styles.statusDot} aria-hidden="true" />
        </button>
      </Flex>
      <Flex direction="column" justify="center" asChild>
        <a
          href={whatsappHref}
          onClick={handleWhatsappClick}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.textContent}
          aria-hidden={!expanded}
          tabIndex={expanded ? 0 : -1}
        >
          <Heading size="sm" asChild>
            <span className={styles.title}>Entenda seus direitos</span>
          </Heading>
          <Caption asChild>
            <span className={styles.subtitle}>Tire suas dúvidas gratuitamente</span>
          </Caption>
        </a>
      </Flex>
    </div>
  )
}
